///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup = abcsetup || {};

abcsetup.alert_boxes = {
    init: function() {
        $('.collapsible').each(function() {
            if ($(this).height() > 150) {
                $(this).addClass('expanded');
                $(this).append('<div class="collapsible-cta"><a href="#" class="collapsible-toggle"></a></div>');
            }
        });

        $(document).on('click', '.collapsible-toggle', function(e) {
            e.preventDefault();
            $(this).closest('.collapsible').toggleClass('collapsed');
            $(this).closest('.collapsible').toggleClass('expanded');
        });
    }
};

abcsetup.alert_boxes.init();